/**
 * Every locale any brand can serve, and the default.
 *
 * Deliberately brand-independent. `i18n/routing.ts` builds `createNavigation()`
 * and the intl middleware from these values at module scope, and that module
 * runs in the browser too, where the brand is unknown: one image serves all
 * four brands and `process.env.BRAND` is not in the bundle
 * (spec/70-Standards/70.13-Runtime-Configuration.md). A per-brand list here
 * resolved to `['de']` in the browser while the server used `['de', 'fr']` on
 * fit4school.ch, so client-side navigation there parsed `/fr/…` URLs as plain
 * paths and built hrefs without the prefix.
 *
 * Which of these a brand actually offers is a server-side question, answered by
 * `getActiveDomainLocales()`. `proxy.ts` rejects a locale prefix the active
 * brand does not offer, so the wider list here never makes `/fr/…` reachable
 * on a German brand.
 */
export const ALL_LOCALES = ['de', 'fr'] satisfies [string, ...string[]];

export const DEFAULT_LOCALE = 'de';

/**
 * Locales per brand. A brand missing here, or listed with a single locale,
 * has no language switcher.
 *
 * Lives in this leaf module rather than in `lib/domain-config.ts` so that
 * `proxy.ts` can read it: the middleware is bundled in its own layer and
 * deliberately does not import `domain-config`, it reads its switches off
 * `process.env` directly.
 */
export const LOCALES_BY_BRAND: Record<string, string[]> = {
  ch: ['de', 'fr'],
};
